import * as Interfaces from '../interfaces/table';

export class TableBody implements Interfaces.TableBody {
    public constructor(id: string) {

        this.data = [];
        this.rowNum = 0;
        this.id = id;
    }

    data: any[];
    rowNum: number;
    id: string;
}
